import { isArray, isEmpty, isNil, omit, reduce } from 'lodash'

const getNodes = (filterFunction, shouldFilterChildren) => (result, node) => {
  let resNode

  if (filterFunction(node)) {
    resNode = omit(node, shouldFilterChildren ? 'children' : [])
  }

  if (isArray(node.children) && shouldFilterChildren(node)) {
    const children = reduce(
      node.children,
      getNodes(filterFunction, shouldFilterChildren),
      [],
    )

    if (!isEmpty(children)) {
      resNode = { ...node, children }
    }
  }

  if (!isNil(resNode)) {
    result.push(resNode)
  }

  return result
}

const filterTree = (array, filterFunction, shouldFilterChildren) =>
  reduce(array, getNodes(filterFunction, shouldFilterChildren), [])

export default filterTree
